import http from "../../../../../core/utils/apis/skillApi";

const SkillsReportsService = {
  searchUserSkill: (skillName) =>
    http.get(`/skills-reports/search/${skillName}`),

  getSkillDistributionByCategory: () =>
    http.get("/skills-reports/skill-distribution-by-categories"),

  getTopSkillsByDepartment: () =>
    http.get("/skills-reports/top-skills-by-department"),

  getSkillAcquisitionProgress: () =>
    http.get("/skills-reports/skill-acquisition-progress"),

  getManualRequestsStats: () =>
    http.get("/skills-reports/manual-requests-stats"),

  getCertifiedRequestsStats: () =>
    http.get("/skills-reports/certified-requests-stats"),

  getRequestsByDepartment: () =>
    http.get("/skills-reports/requests-by-department"),

  getCertifiedRequestsByDepartment: () =>
    http.get("/skills-reports/requests-by-department/certified"),

  getSkillLevelsDistribution: () =>
    http.get("/skills-reports/skill-levels-distribution"),


  getSkillCategories: () => http.get("/skills-reports/skill-categories"),

  getDepartments: () => http.get("/users/departments"),

  getSkillLevelsDistributionMultiFilter: (categories, teams) =>
    http.get(`/skills-reports/level-distribution/filter`, {
      params: {
        categories: categories.join(","),
        teams: teams.join(","),
      },
    }),

  searchUsersByName: (query) => http.get(`/users/search/${query}`),
  searchSkillsByName: (name) => http.get(`/skills/search/${name}`),
};

export default SkillsReportsService;
